// @TODO: ALTERAR O ID DO TYPE

export const isDocumentACP = (type: number) => (type === 1);

export default isDocumentACP;
